import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "shared/components/ConnectionAvatars/index.scss";


function ConnectionAvatars({
	myThumb,
	theirThumb,
	theirUsername,
	theyIntrod,
	theyLikedWhileBoosted,
}) {
	const outerHaloClasses = classnames(
		"connection-avatars-halo connection-avatars-halo--outer",
		{
			"connection-avatars-halo--outer--intro": theyIntrod,
			"connection-avatars-halo--outer--boosted": theyLikedWhileBoosted,
		},
	);

	const innerHaloClasses = classnames(
		"connection-avatars-halo connection-avatars-halo--inner",
		{
			"connection-avatars-halo--inner--intro": theyIntrod,
			"connection-avatars-halo--inner--boosted": theyLikedWhileBoosted,
		},
	);

	return (
		<div className="connection-avatars">
			<span className={outerHaloClasses}>
				<span className={`${innerHaloClasses} connection-avatars-halo--inner--their`}>
					<img className="connection-avatars-thumb" src={theirThumb} alt={theirUsername} />
				</span>
			</span>

			<span className={outerHaloClasses}>
				<span className={innerHaloClasses}>
					<img className="connection-avatars-thumb" src={myThumb} alt="you" />
				</span>
			</span>
		</div>
	);
}

ConnectionAvatars.propTypes = {
	myThumb: PropTypes.string.isRequired,
	theirThumb: PropTypes.string.isRequired,
	theirUsername: PropTypes.string.isRequired,
	theyIntrod: PropTypes.bool,
	theyLikedWhileBoosted: PropTypes.bool,
};

ConnectionAvatars.defaultProps = {
	theyIntrod: false,
	theyLikedWhileBoosted: false,
};


export default ConnectionAvatars;



// WEBPACK FOOTER //
// ./src/shared/components/ConnectionAvatars/index.jsx